import midString from '@/utils/mid-string'

export default {
  newSortkeyLastInList (workflow) {
    let lastRequirementSortkey = ''
    const lastCard = this.getLastCardOnSortKey(workflow)
    if (lastCard) {
      lastRequirementSortkey = lastCard.sortkey
    }
    const sortkey = this.generateNewSortKey(lastRequirementSortkey)
    return sortkey
  },

  newSortkeyNextInList (workflow, sortkey) {
    const cards = this.getCardsFromSortkey(workflow, sortkey, 2)
    const afterKey = cards[0]?.sortkey
    const beforeKey = cards[1]?.sortkey
    const newSortkey = this.generateNewSortKey(afterKey, beforeKey)
    return newSortkey
  },

  getLastCardOnSortKey (workflow) {
    let lastCard
    const sortedCards = getSortedRequirements(workflow)
    if (sortedCards?.length > 0) {
      lastCard = sortedCards[sortedCards.length - 1]
    }
    return lastCard
  },

  getCardsFromSortkey (workflow, sortkey, numberOfCards) {
    let counter = 0
    const res = []
    const sortedRequirements = getSortedRequirements(workflow)
    if (sortedRequirements?.length > 0) {
      const index = sortedRequirements.findIndex(requirement => requirement.sortkey === sortkey)
      if (index >= 0) {
        for (let i = index; i < sortedRequirements.length; i++) {
          res.push(sortedRequirements[i])
          counter++
          if (counter === numberOfCards) {
            break
          }
        }
      }
    }
    return res
  },

  generateNewSortKey (after = '', before = '') {
    const newSortkey = midString(after, before)
    return newSortkey
  },

  sortByReleaseAndSortKey (cards) {
    cards.sort((a, b) => {
      if (a.releaseNo !== b.releaseNo) {
        if (a.releaseNo === undefined || a.releaseNo === null) return 1 // Place 'a' after 'b' if 'a.releaseNo' is undefined
        if (b.releaseNo === undefined || b.releaseNo === null) return -1 // Place 'b' after 'a' if 'b.releaseNo' is undefined
        return a.releaseNo - b.releaseNo // Ascending order by releaseNo
      }
      return a.sortkey.localeCompare(b.sortkey)
    })
  },

  moveCard (ev, requirementsJson, cardsByTypes, cardTypeId) {
    const { item, newIndex } = ev
    const { cardId } = item.dataset
    const card = requirementsJson.find(({ id }) => id === cardId)

    const prevCard = cardsByTypes[cardTypeId][newIndex - 1]
    const nextCard = cardsByTypes[cardTypeId][newIndex + 1]
    const prevSortKey = prevCard && ((nextCard && prevCard.releaseNo === nextCard.releaseNo) || (ev.newIndex > ev.oldIndex))
      ? prevCard.sortkey
      : ''
    const nextSortKey = nextCard && ((prevCard && prevCard.releaseNo === nextCard.releaseNo) || (ev.newIndex < ev.oldIndex))
      ? nextCard.sortkey
      : ''
    const sortkey = midString(prevSortKey, nextSortKey)

    const releaseNo = (ev.newIndex > ev.oldIndex ? prevCard : nextCard)?.releaseNo || null

    return { ...card, sortkey, releaseNo, cardTypeId }
  }
}

function getAllRequirements (workflow) {
  let requirements = []
  if (!workflow.eventsJson) return
  for (const event of workflow.eventsJson) {
    if (event.requirementsJson) {
      requirements = requirements.concat(event.requirementsJson)
    }
  }
  return requirements
}

function getSortedRequirements (workflow) {
  let sortedRequirements = []
  const allRequirements = getAllRequirements(workflow)
  if (allRequirements?.length > 0) {
    sortedRequirements = allRequirements.sort(
      (a, b) => a.sortkey < b.sortkey ? -1 : 1
    )
  }
  return sortedRequirements
}
